export default "__VITE_ASSET__DU1SuXVj__"